export const COOKIE_MODAL_IDENTIFIER = 'kmcc-cookie-modal';
export const TOC_IDENTIFIER = '.js-kmcc-cookie-modal__aside__navigation li a';
export const MODAL_CONTENT_WRAPPER_IDENTIFIER = 'kmcc-modal-content-wrapper';
export const DETAIL_CONTENT_WRAPPER_IDENTIFIER = 'kmcc-detail-content';
export const CLASSES = {
    PAGE: 'kmcc-cookie-modal--page',
    VISIBLE: 'kmcc-cookie-modal--visible',
    DETAIL_OPEN: 'kmcc-cookie-modal--detail-open',
};



// WEBPACK FOOTER //
// ./vendor/kunstmaan/cookie-bundle/Resources/ui/js/config/cookiemodal.config.js